import { maxLength, PropertyMapping, propertyMapping, required } from '@hakla/typed-forms'
import { ProjectPartner, ProjectResponse, ResourceVariant } from '@/api/generated'
import { updateOrAppend } from '@/shared/utils/list'
import { compareBy } from '@/shared/utils/compare-by'

export interface EditProjectForm {
  categories: string[]
  description: string
  gallery: ResourceVariant[]
  logo: ResourceVariant
  name: string
  partners: ProjectPartner[]
  shortDescription: string
  visible: boolean

  header: {
    resources: ResourceVariant[]
  }
}

export function editProjectFormMapping(
  isKonstanz: boolean = false
): PropertyMapping<ProjectResponse, EditProjectForm> {
  return propertyMapping(({ generic, nested }) => {
    let shortDescription = generic('shortDescription')

    if (isKonstanz === false) {
      shortDescription = shortDescription.validations(maxLength(300))
    }

    return {
      categories: generic('categories'),
      description: generic('description'),
      gallery: generic('gallery')
        .deserializeWith(value => {
          return value.resources.find(resource => resource.name === 'gallery')?.resources || []
        })
        .serializeWith((model, form) => {
          model.resources = updateOrAppend(
            model.resources,
            {
              name: 'gallery',
              resources: form.gallery,
            },
            compareBy('name')
          )
        }),

      header: nested('header').properties(builders => {
        return {
          resources: builders
            .generic('resources')
            .initializeWith([])
            .deserializeWith(value => {
              return value.resources.find(resource => resource.name === 'header')?.resources || []
            })
            .serializeWith((model, form) => {
              model.resources = updateOrAppend(
                model.resources,
                {
                  name: 'header',
                  resources: form.resources,
                },
                compareBy('name')
              )
            }),
        }
      }),

      logo: generic('logo')
        .deserializeWith(value => {
          return value.resources.find(resource => resource.name === 'logo')?.resources[0]
        })
        .serializeWith((model, form) => {
          model.resources = updateOrAppend(
            model.resources,
            { name: 'logo', resources: [form.logo] },
            compareBy('name')
          )
        }),

      name: generic('name').validations(required),
      partners: generic('partners'),
      shortDescription,
      visible: generic('visible'),
    }
  })
}
